import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import { PhoneNumberComponent } from "../../dropdown/PhoneNumberComponent";
import { getStorageData } from "../../utils/Validate";
import { valHooks } from "jquery";
import CustomerDocuments from "../../components/customerMaster/CustomerDocuments";
import AdditionalContact from "../../components/customerMaster/AdditionalContact";


const style = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "35px",
    height: "auto",
    alignItems: "center",
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
  }),

  valueContainer: (provided) => ({
    ...provided,
    display: "flex",
    flexWrap: "wrap",
    overflow: "visible",
    padding: "2px 8px",
  }),

  multiValue: (provided) => ({
    ...provided,
    margin: "1px 2px",
  }),

  input: (provided) => ({
    ...provided,
    margin: "0px",
    padding: "0px",
  }),

  indicatorsContainer: (provided) => ({
    ...provided,
    height: "33px",
  }),

  clearIndicator: (provided) => ({
    ...provided,
    padding: "4px",
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "4px",
  }),
};

const Option = (props) => {
  return (
    <div className="d-flex align-items-center">
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          className="mr-1"
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

const CustomerDetails = ({
  handleFormChange,
  formValues,
  countrydata,
  country,
  formErrors,
  formError,
  handleCountryChange,
  handleCustomerType,
  CustomerTypeData,
  handleSalesEngChange,
  handleDistributorType,
  salesEngineer,
  distributortype,
  distributorTypeData,
  handleFormSubmit,
  setCountry,
  setContactShow,
  contactShow,
  contact,
  deleteContact,
  EditContact,
  disabled,
  setDistributortype,
  selectedOptions,
  setSelectedOption,
  salesEngineerData,
  setSalesEngineerData,
  customerStatusData,
  setCustomerStatusData,
  handleStatusChange,
  setFormValues,
  clearFormValues,
  handleDocumentChange,
  errors,
  removeAttachedFile,
  documentList,
  handleAttachmentDate,
  docError,
  setDocError,
  setFormErrors
}) => {
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const [SalesEngdrp, setSalesEngdrp] = useState([]);

  const [CustomerTypeDatas, setCustomerTypeDatas] = useState([]);
  const [customerTypeDrp, setCustomerTypeDrp] = useState([]);

  const [distributorTypeDrp, setDistributorTypeDrp] = useState([]);

  const [customerStatus, setCustomerStatus] = useState([
    { id: 1, status: "Active" },
    { id: 2, status: "Inactive" },
    { id: 3, status: "Blacklisted" },
    { id: 4, status: "Order Blocked" },
    { id: 5, status: "Delivery Blocked" },
    { id: 6, status: "Documents Not Submitted" },
    { id: 7, status: "Documents Expired" },
  ]);

  useEffect(() => {
    setDistributorTypeDrp(distributorTypeData)
  }, [distributorTypeData])

  useEffect(() => {
    setCustomerTypeDatas(CustomerTypeData);
  }, [CustomerTypeData]);

  useEffect(() => {
    const getCustomerTypeData = () => {
      if (CustomerTypeDatas) {
        const list = formatcustomerTypeDrp(CustomerTypeDatas);
        setCustomerTypeDrp(list);
      }
    };
    getCustomerTypeData();
  }, [CustomerTypeDatas]);

  const formatcustomerTypeDrp = (list) => {
    var te = list?.map((data, index) => ({
      label: data?.type,
      value: data?.id,
    }));
    return te;
  };

  useEffect(() => {
    if (!formValues?.type) return;

    const transformedOptions = customerTypeDrp
      .filter(item => formValues.type.includes(item.value.toString()))
      .map(({ label, value }) => ({ label, value }));

    setSelectedOption(transformedOptions);
  }, [customerTypeDrp, formValues?.type]);


  useEffect(() => {
    const userProf = getStorageData();
    const userProfId = userProf?.userCompanyId;
    if (userProf?.userType === 2) setFormValues({ ...formValues, distributorId: userProfId })
  }, [distributorTypeDrp])

  useEffect(() => {
    if (distributortype?.defaultCompanyDistributor === true) {
      setSalesEngdrp(salesEngineer?.filter(item => item?.userType === 1 && (item?.isActive===true || item?.identityId ===formValues?.assignedEngineerId)))
    } else {
      setSalesEngdrp(salesEngineer?.filter(item => item?.userCompanyId === distributortype?.value && (item?.isActive===true || item?.identityId ===formValues?.assignedEngineerId)))
    }
  }, [salesEngineer, distributortype]);

  return (
    <>

      <div class="card header-card">
        <div className="card-body">
          <div className="row">
            <div className="col-12">
              <div className="card general-info-card mb-2">
                <div className="card-header">
                  <h2>General Information</h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>
                              Customer Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="customerName"
                              name="customerName"
                              placeholder={PlaceHolder?.CUSTOMER_NAME}
                              value={formValues.customerName}
                              onChange={handleFormChange}
                            />
                            {formErrors.customerName && (
                              <p className="form-error">{formErrors.customerName}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>
                              Address <span className="mandatory">*</span>
                            </label>
                            <textarea
                              className="form-control address-text-area"
                              name="address"
                              value={formValues?.address}
                              placeholder={PlaceHolder?.ADDRESS}
                              rows="5"
                              onChange={handleFormChange}
                            ></textarea>
                            {formErrors?.address && (
                              <p className="form-error">{formErrors?.address}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>
                              Customer Type <span className="mandatory">*</span>
                            </label>
                            <Select
                              className="basic-multi-select"
                              isMulti
                              closeMenuOnSelect={false}
                              hideSelectedOptions={false}
                              options={customerTypeDrp}
                              allowSelectAll={true}
                              onChange={handleCustomerType}
                              value={selectedOptions}
                              name="type"
                              styles={style}
                              components={{
                                Option,
                              }}
                              placeholder={PlaceHolder?.SELECT_CUSTOMER_TYPE}
                            />
                            {formErrors.type && (
                              <p className="form-error">{formErrors.type}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>
                              Email Address <span className="mandatory">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="email"
                              type="text"
                              id="email"
                              placeholder={PlaceHolder?.EMAIL_ADDRESS}
                              value={formValues.email}
                              onChange={handleFormChange}
                            ></input>
                            {formErrors.email && (
                              <p className="form-error">{formErrors.email}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>
                              Country <span className="mandatory">*</span>
                            </label>
                            <DropDownComponent
                              pageName="Customer"
                              dpDownName="country"
                              stateData={countrydata}
                              controlName="countrydrp"
                              placeHolder={PlaceHolder?.SELECT_COUNTRY}
                              handleChange={handleCountryChange}
                              value={country}
                              valueId={formValues?.countryId}
                              setState={setCountry}
                              isDisabled={userProfile?.userType === 2 ? true : false}
                            />
                            {formErrors.countryId && (
                              <p className="form-error">{formErrors.countryId}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>
                              Phone Number <span className="mandatory">*</span>
                            </label>
                            <PhoneNumberComponent defaultCountry={country?.code} errors={formErrors} setValues={setFormValues} setErrors={setFormErrors} filedName="phone" values={formValues} />
                            {formErrors.phone && (
                              <p className="form-error">{formErrors.phone}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>
                              Fax Number
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="fax"
                              name="fax"
                              placeholder={PlaceHolder?.FAX}
                              value={formValues.fax}
                              onChange={handleFormChange}
                            />
                            {formErrors.fax && (
                              <p className="form-error">{formErrors.fax}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>
                              Website
                            </label>
                            <input
                              className="form-control"
                              name="website"
                              type="url"
                              id="website"
                              value={formValues.website}
                              placeholder={PlaceHolder?.WEB_SITE}
                              onChange={handleFormChange}
                            ></input>
                            {formErrors.website && (
                              <p className="form-error">{formErrors.website}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          {formValues?.id && (
                            <>
                              <label>Status</label>
                              <DropDownComponent
                                pageName="Customer"
                                dpDownName="customerStatus"
                                stateData={customerStatus}
                                controlName="statusId"
                                placeHolder="Choose status"
                                handleChange={handleStatusChange}
                                value={customerStatusData}
                                valueId={formValues?.statusId}
                                setState={setCustomerStatusData}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row"></div>
                </div>
                <div className="card-header">
                  <h2>Distributor Info</h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                      <div>
                        <label>
                          Distributor <span className="mandatory">*</span>
                        </label>
                        <DropDownComponent
                          pageName="customer"
                          placeHolder={PlaceHolder?.SELECT_DISTRIBUTOR}
                          dpDownName="distributor"
                          stateData={distributorTypeDrp}
                          controlName="distributorId"
                          handleChange={handleDistributorType}
                          value={distributortype}
                          valueId={formValues?.distributorId}
                          setState={setDistributortype}
                          isDisabled={getStorageData()?.userType === 2 ? true : false} />
                        {formErrors.distributorId && (
                          <p className="form-error">{formErrors.distributorId}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                      <div>
                        <label>
                          Sales Engineer <span className="mandatory">*</span>
                        </label>
                        <DropDownComponent
                          pageName="customer"
                          placeHolder={formValues?.distributorId ? PlaceHolder?.SELECT_ENGINEER : PlaceHolder?.MUST_CHOOSE_FIELD("distributor", "sales engineer")}
                          dpDownName="allocatedTo"
                          stateData={SalesEngdrp}
                          controlName="assignedEngineerId"
                          handleChange={handleSalesEngChange}
                          value={salesEngineerData}
                          valueId={formValues?.assignedEngineerId}
                          setState={setSalesEngineerData} />

                        {formErrors.assignedEngineerId && (
                          <p className="form-error">{formErrors.assignedEngineerId}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                {/* <!-- Add Documents--> */}
                <CustomerDocuments
                  DocumentsName="Documents"
                  formValues={formValues}
                  formError={formError}
                  setFormValues={setFormValues}
                  handleDocumentChange={handleDocumentChange}
                  errors={errors}
                  removeAttachedFile={removeAttachedFile}
                  documentList={documentList}
                  handleAttachmentDate={handleAttachmentDate}
                  docError={docError}
                  setDocError={setDocError}
                />
                {/* <!-- Additional Contact--> */}
                <AdditionalContact
                  setContactShow={setContactShow}
                  contactShow={contactShow}
                  contact={contact}
                  deleteContact={deleteContact}
                  EditContact={EditContact}
                  formValues={formValues}
                  handleFormSubmit={handleFormSubmit}
                  clearFormValues={clearFormValues}
                  disabled={disabled}
                />
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default CustomerDetails;
